<template>
	<!-- 关于我们 -->
	<div class="content1">
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>

		<nemunav :list="navList" navBgImg="medium" :menutitle="menutitle" @tapMenu="tapMenu" :navIndex="selectIndex">
		</nemunav>

		<medium1 v-if="selectIndex==0" :list="list"></medium1>
		<medium2 v-if="selectIndex==1" :list1="xwlist1" :list2="xwlist2"></medium2>

		<footer1></footer1>
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	import mobilemenu from "@/components/en/mobile-menu.vue";
	import header1 from "@/components/en/header.vue";
	import nemunav from "@/components/en/nemunav.vue";
	import medium1 from "@/components/en/meidum/index1.vue";
	import medium2 from "@/components/en/meidum/index2.vue";
	import footer1 from "@/components/en/footer.vue";
	import {
		contentlisten
	} from '@/api/home.js';
	export default {
		components: {
			mobilemenu,
			header1,
			footer1,
			nemunav,
			medium1,
			medium2
		},
		data() {
			return {
				pathname: "/en/medium",
				menutitle: "Medium",
				navList: ["Enterprise Chronicle", "News"],
				selectIndex: 0,
				isShowMobile: false,
				list: [],
				xwlist2: [],
				xwlist1: [],
				pageNum: 1
			}
		},
		created() {
			// window.addEventListener('resize', this.updateWidth);
			this.selectIndex = this.$route.query.index ? this.$route.query.index : 0
			this.getcontentlist()
			this.getxwcontentlist1()
			this.getxwcontentlist2()
		},
		methods: {
			updateWidth() {
				const width = window.innerWidth;
				if (width < 880) {
					this.list = this.getMapping(this.oldlist, 1)
				} else {
					this.list = this.getMapping(this.oldlist, 4)
				}
			},
			updateWidth1() {
				const width = window.innerWidth;
				if (width < 880) {
					this.xwlist2 = this.getMapping(this.oldnewlist, 1)
				} else {
					this.xwlist2 = this.getMapping(this.oldnewlist, 3)
				}
			},
			getcontentlist() {
				contentlisten({
					pageNum: this.pageNum,
					pageSize: 10,
					companyId: 1,
					categoryId: 441
				}).then(res => {
					if (res.data.code == 200) {
						var arr1 = []
						var arr = res.data.rows
						for (var i = 0; i < arr.length; i++) {
							var item = arr[i]
							var str1 = item.bcontent.replace(/<\/p>/g, "");
							var str2 = str1.replace(/<p>/g, "");
							var str3 = str2.replace(/<brp>/g, "");
							item['content1'] = str3
							arr1.push(item)
						}
						this.list = arr
						console.log(this.list, "0000000")
					}
				})
			},
			filterHtmlTags(htmlString) {
			  // 创建临时容器解析HTML
			  const parser = new DOMParser();
			  const doc = parser.parseFromString(htmlString, 'text/html');
			  
			  // 获取所有<p>标签并过滤空段落
			  const paragraphs = Array.from(doc.querySelectorAll('p')).filter(p => {
			    // 移除<br>标签后检查内容是否为空
			    return !(p.childElementCount === 1 && p.firstElementChild.tagName === 'BR') && 
			           p.textContent.trim() !== '';
			  });
			
			  // 构建干净的内容字符串
			  return paragraphs.map(p => p.outerHTML).join('');
			},
			getMapping(list) {
				let len = list.length
				let newList = []
				if (len) {
					var chunk = 4
					for (var i = 0, j = len; i < j; i += chunk) {
						newList.push(list.slice(i, i + chunk))
					}
				}
				return newList
			},

			getxwcontentlist2() {
				contentlisten({
					pageNum: this.pageNum,
					pageSize: 100,
					companyId: 1,
					categoryId: 442,
					bdeviceType: 2
				}).then(res => {
					if (res.data.code == 200) {
						var arr1 = []
						var arr = res.data.rows
						for (var i = 0; i < arr.length; i++) {
							var item = arr[i]
							item['content1'] = this.filtersText(item.bcontent)
							arr1.push(item)
						}
						this.oldnewlist = arr1
						this.updateWidth1()
						console.log(this.xwlist2, "00000----")
					}
				})
			},
			getxwcontentlist1() {
				contentlisten({
					pageNum: this.pageNum,
					pageSize: 10,
					companyId: 1,
					categoryId: 442,
					bdeviceType: 1
				}).then(res => {
					if (res.data.code == 200) {
						var arr1 = []
						var arr = res.data.rows
						for (var i = 0; i < arr.length; i++) {
							var item = arr[i]
							item['content1'] = this.filtersText(item.bcontent)
							arr1.push(item)
						}
						this.oldnewlist = arr1
						this.updateWidth1()
					}
				})
			},
			updateWidth1() {
				const width = window.innerWidth;
				if (width < 880) {
					this.xwlist2 = this.getMapping(this.oldnewlist, 1)
				} else {
					this.xwlist2 = this.getMapping(this.oldnewlist, 3)
				}
			},
			filtersText(val) {
				if (val != null && val != '') {
					let reg = /[\u4e00-\u9fa5]/g;
					let names = val.match(reg);
					val = names ? names.join('') : '';
					return val;
				} else return '';
			},
			filterHtmlTags(htmlString) {
			  // 创建临时容器解析HTML
			  const parser = new DOMParser();
			  const doc = parser.parseFromString(htmlString, 'text/html');
			  
			  // 获取所有<p>标签并过滤空段落
			  const paragraphs = Array.from(doc.querySelectorAll('p')).filter(p => {
			    // 移除<br>标签后检查内容是否为空
			    return !(p.childElementCount === 1 && p.firstElementChild.tagName === 'BR') && 
			           p.textContent.trim() !== '';
			  });
			
			  // 构建干净的内容字符串
			  return paragraphs.map(p => p.outerHTML).join('');
			},

			tapMenu(e) {
				this.selectIndex = e
			},
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			}

		}
	}
</script>

<style lang="scss">
	@media screen and (min-width: 1200px) {
		.content1 {
			padding-top: 100px;
		}

	}

	@media screen and (max-width: 1200px) {
		.content1 {
			padding-top: 80px;
		}

	}

	@media screen and (max-width: 880px) {
		.content1 {
			padding-top: 50px;
		}

	}
</style>